import React, { useEffect, useState } from "react";
import { Box, Container, LinearProgress, Typography, Paper, Avatar } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import bkstApi from "../../common/component/api";
import { BAKER_PIC_FOLDER } from "../../common/component/constants";
import moment from "moment";

export default function Terminal(props) {
  const [terminals, setTerminals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    bkstApi.get(`/admin/terminal`)
      .then((res) => {
        // Handle different possible response structures
        const data = res.data;
        console.log('API Response:', data);
        console.log('Response type:', typeof data);
        console.log('Is array:', Array.isArray(data));
        
        const terminalsArray = Array.isArray(data) ? data : 
                              Array.isArray(data.terminals) ? data.terminals :
                              Array.isArray(data.data) ? data.data : [];
        
        console.log('Terminals array:', terminalsArray);
        setTerminals(terminalsArray);
        setLoading(false);
      })
      .catch((err) => {
        console.error('API Error:', err);
        setError(err.message || 'Failed to fetch terminals');
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <LinearProgress />;
  }

  if (error) {
    return (
      <Container maxWidth="md">
        <Box my={4}>
          <Typography variant="h4" color="error" gutterBottom>
            Error
          </Typography>
          <Typography variant="body1" color="textSecondary">
            {error}
          </Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg">
      <Box my={4}>
        <Typography variant="h3" gutterBottom>
          Stripe Terminals ({terminals.length})
        </Typography>
        <Paper elevation={1} sx={{ p: 3, mt: 3 }}>
         
          <div style={{ height: 600, width: '100%' }}>
            <DataGrid
              rows={terminals.map((terminal, index) => ({
                id: terminal.id || index,
                account: terminal.metadata?.accountId || 'N/A',
                name: terminal.label || 'N/A',
                status: terminal.status || 'N/A',
                lastSeen: terminal.last_seen_at || null
              }))}
              columns={[
                {
                  field: 'account',
                  headerName: 'Account',
                  flex: 1,
                  minWidth: 200,
                  renderCell: (params) => (
                    <Avatar 
                      src={`${BAKER_PIC_FOLDER}/${params.value}/logo400.webp`} 
                      sx={{ width: 32, height: 32 }}
                    />
                  )
                },
                {
                  field: 'name',
                  headerName: 'Name',
                  flex: 1,
                  minWidth: 200
                },
                {
                  field: 'status',
                  headerName: 'Status',
                  flex: 1,
                  minWidth: 150,
                  renderCell: (params) => (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Box
                        sx={{
                          width: 12,
                          height: 12,
                          borderRadius: '50%',
                          backgroundColor: params.value === 'online' ? '#4caf50' : '#f44336'
                        }}
                      />
                      <Typography variant="body2" sx={{ textTransform: 'capitalize' }}>
                        {params.value}
                      </Typography>
                    </Box>
                  )
                },
                {
                  field: 'lastSeen',
                  headerName: 'Last Seen',
                  flex: 1,
                  minWidth: 150,
                  renderCell: (params) => (
                    <Typography variant="body2" color="textSecondary">
                      {params.value ? moment(params.value).fromNow() : 'Never'}
                    </Typography>
                  )
                }
              ]}
              pageSize={10}
              rowsPerPageOptions={[10, 25, 50]}
              disableSelectionOnClick
              sx={{
                border: "1px solid #ececec",
                fontSize: "1.05em",
                background: "#fff",
                "& .MuiDataGrid-columnHeaders": { background: "#f7f7f7", fontWeight: 600 },
                "& .MuiDataGrid-cell": {
                  whiteSpace: "pre-wrap",
                  lineHeight: 1.6,
                  alignItems: "center",
                  py: 1
                }
              }}
            />
          </div>
        </Paper>
      </Box>
    </Container>
  );
} 